// src/components/tables/GenericTable/TableHeaderRow.tsx

import React from "react";
import styled from "styled-components";

export interface TableHeaderRowProps {
  children: React.ReactNode;
  sticky?: boolean;
  compact?: boolean;
  hiddenOnMobile?: boolean;
  columnTemplate?: string;
}

const StyledHeaderRow = styled.div<{
  sticky?: boolean;
  compact?: boolean;
  hiddenOnMobile?: boolean;
  columnTemplate?: string;
}>`
  display: grid;
  grid-template-columns: ${({ columnTemplate }) => columnTemplate || "auto"};
  align-items: center;
  padding: ${({ theme, compact }) =>
    compact ? theme.spacing.sm : theme.spacing.md};
  border-radius: ${({ theme }) => theme.radii.md};
  background: ${({ theme }) => theme.colors.surfaceDisabled};
  font-weight: ${({ theme }) => theme.fonts.fontWeightBold};
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  color: ${({ theme }) => theme.colors.textSecondary};
  box-shadow: ${({ theme }) => theme.elevations.low};
  transition: box-shadow 0.2s;

  ${({ sticky, theme }) =>
    sticky &&
    `
    position: sticky;
    top: 0;
    z-index: 100;
    box-shadow: ${theme.elevations.md};
  `}

  ${({ hiddenOnMobile, theme }) =>
    hiddenOnMobile &&
    `
    @media (max-width: ${theme.breakpoints.tablet}) {
      display: none;
    }
  `}
`;

export const TableHeaderRow: React.FC<TableHeaderRowProps> = ({
  children,
  sticky = false,
  compact = false,
  hiddenOnMobile = true,
  columnTemplate,
}) => {
  return (
    <StyledHeaderRow
      sticky={sticky}
      compact={compact}
      hiddenOnMobile={hiddenOnMobile}
      columnTemplate={columnTemplate}
    >
      {children}
    </StyledHeaderRow>
  );
};